var _path, _path2, _path3, _path4, _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgChartUp = function SvgChartUp(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20C40.001 8.9543 31.0467 -1.35705e-06 20.001 -8.74228e-07C8.95528 -3.91405e-07 0.000975205 8.95431 0.000975688 20C0.000976171 31.0457 8.95528 40 20.001 40C31.0467 40 40.001 31.0457 40.001 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 40.0015C31.0467 40.0015 40.001 31.0472 40.001 20.0015C40.001 8.95577 31.0467 0.00146484 20.001 0.00146484C8.95528 0.00146484 0.000976562 8.95577 0.000976562 20.0015C0.000976562 31.0472 8.95528 40.0015 20.001 40.0015Z",
    fill: "url(#paint0_radial_147_643)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20C40.001 8.9543 31.0467 -1.35705e-06 20.001 -8.74228e-07C8.95528 -3.91405e-07 0.000975205 8.95431 0.000975688 20C0.000976171 31.0457 8.95528 40 20.001 40C31.0467 40 40.001 31.0457 40.001 20Z",
    fill: "url(#paint1_linear_147_643)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20C40.001 8.9543 31.0467 -1.35705e-06 20.001 -8.74228e-07C8.95528 -3.91405e-07 0.000975205 8.95431 0.000975688 20C0.000976171 31.0457 8.95528 40 20.001 40C31.0467 40 40.001 31.0457 40.001 20Z",
    fill: "url(#paint2_radial_147_643)",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_147_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 20.9165H18.1667C17.6607 20.9165 17.25 21.3272 17.25 21.8332V30.0832C17.25 30.5892 17.6607 30.9998 18.1667 30.9998H21.8333C22.3393 30.9998 22.75 30.5892 22.75 30.0832V21.8332C22.75 21.3272 22.3393 20.9165 21.8333 20.9165Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5833 24.5835H9.91667C9.41067 24.5835 9 24.9942 9 25.5002V30.0835C9 30.5895 9.41067 31.0002 9.91667 31.0002H13.5833C14.0893 31.0002 14.5 30.5895 14.5 30.0835V25.5002C14.5 24.9942 14.0893 24.5835 13.5833 24.5835Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0833 17.25H26.4167C25.9107 17.25 25.5 17.6607 25.5 18.1667V30.0833C25.5 30.5893 25.9107 31 26.4167 31H30.0833C30.5893 31 31 30.5893 31 30.0833V18.1667C31 17.6607 30.5893 17.25 30.0833 17.25Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6482 17.8981L26.4168 12.1295V15.4167H28.2501V9.91667C28.2501 9.41067 27.8395 9 27.3335 9H21.8335V10.8333H25.1206L20.0001 15.9538L16.9816 12.9353C16.6231 12.5768 16.0438 12.5768 15.6854 12.9353L11.1021 17.5186L12.3982 18.8148L16.3335 14.8795L19.3521 17.8981C19.7105 18.2565 20.2898 18.2565 20.6482 17.8981Z",
    fill: "#001947"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_147_643)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5002 30C16.4789 30 27.0002 19.4787 27.0002 6.50003C27.0002 4.6177 26.7789 2.78706 26.3609 1.03271C34.2882 3.69003 40.0002 11.178 40.0002 20C40.0002 31.0457 31.0459 40 20.0002 40C12.5914 40 6.12351 35.9715 2.66748 29.9856C2.94387 29.9952 3.22147 30 3.5002 30Z",
    fill: "url(#paint3_linear_147_643)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_147_643",
    x: 1.33415,
    y: -0.300619,
    width: 39.9992,
    height: 41.634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.666667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_147_643"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_147_643",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_147_643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9271 9.93628e-05) rotate(135) scale(34.9872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_147_643",
    x1: 18.3343,
    y1: -3.33334,
    x2: 0.000973962,
    y2: 23.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#00F47F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_147_643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26 9.5) rotate(143.291) scale(47.3994 39.1256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610268,
    stopColor: "#00BDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_147_643",
    x1: 21.339,
    y1: 40,
    x2: 26.3304,
    y2: 11.7965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_147_643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(9 9)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart-up.b20c8890.svg";
export { ForwardRef as ReactComponent };